export default __webpack_public_path__ + "navigation-guides-ui-steps-view-controller-960-b63b4b8a21f92fe5eaec793d00c2a842.webp";